/**
 * Clés de requête locales à l'écran Paramètres (`02` §12) — `lib/query/keys.ts`
 * est hors périmètre de cette vague (voir `README-shell.md`). Reprend
 * `queryKeys.settings.maintenance()` du fichier central pour l'onglet
 * Maintenance (même hook que le bandeau global, `use-maintenance-state.ts`)
 * et `queryKeys.stores.list()` pour la liste boutiques (même hook que le
 * sélecteur, `features/stores/use-stores-list.ts`) plutôt que de dupliquer
 * ces deux clés.
 */
export const settingsKeys = {
  general: ['settings', 'general'] as const,
  testMode: ['settings', 'test-mode'] as const,
  ftp: ['settings', 'ftp'] as const,
  pennylane: ['settings', 'pennylane'] as const,
  alerts: ['settings', 'alerts'] as const,
  storeDetail: (code: string) => ['settings', 'stores', 'detail', code] as const,
  productSearch: (code: string, query: string) => ['settings', 'stores', 'product-search', code, query] as const,
};
